// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__9-sND","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__2KTOP"};